import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sucess',
  templateUrl: './sucess.component.html',
  styleUrls: ['./sucess.component.scss']
})
export class ValidateCodeSucessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
